import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=143a0a9c"
import script from "./ExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ExpansionPanel.vue?vue&type=script&lang=ts"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=143a0a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports